import React, { useEffect } from "react";
import style from "./PrivacyPolicy.module.css";
import Icon from "@/ui/icon/Icon";
import Container from "@/layouts/container/Container";
import { Link } from "react-router-dom";
import Logo from "@/ui/logo/Logo";
import Footer from "@/layouts/footer/Footer";

function PrivacyPolicy() {
	return (
		<>
			<Container size="mini">
				<div className={style.grid}>
					<div className={`${style.container} prose`}>
						<div className={style.header}>
							<div className={style.subHeader}>
								<Logo />
								<div className={style.nav}>
									<Link to="../">
										<Icon icon="fa-arrow-left" />
										<span>Nazad</span>
									</Link>
									<Icon icon="fa-slash-forward" />
									<Link to="/terms-and-conditions">
										<span>Uslovi korištenja</span>
										<Icon icon="fa-arrow-right" />
									</Link>
								</div>
							</div>

							<h1>Vaša privatnost je naš prioritet</h1>
							<p>
								Ova Politika privatnosti opisuje kako
								prikupljamo, koristimo i otkrivamo lične podatke
								(kao &scaron;to je definisano u nastavku) o vama
								kada koristite svoj Mentorios&nbsp;račun ili
								bilo koje Mentorios&nbsp;usluge povezane sa ovom
								politikom.{" "}
							</p>
							<div className={style.date}>
								<div className={style.line}></div>
								<span>Ažurirano:</span>
								<span>Februar 2026.</span>
							</div>
						</div>

						<section data-section="introduction">
							<h2 id="introduction">Uvod</h2>
							<p>
								Ova Politika privatnosti opisuje kako
								prikupljamo, koristimo i otkrivamo lične podatke
								o vama kada koristite svoj Mentorios račun ili
								bilo koje Mentorios usluge povezane sa ovom
								politikom.
							</p>
						</section>

						<section data-section="collection">
							<h2 id="collection">
								Prikupljanje ličnih podataka
							</h2>
							<p>
								Lični podaci&nbsp;su bilo koja informacija ili
								kombinacija informacija koje razumno mogu
								dozvoliti va&scaron;u identifikaciju, ili koje
								se razumno mogu povezati s vama. Podaci koji su
								agregirani ili deidentifikovani tako da
								vi&scaron;e nisu razumno povezani sa
								identifikovanom fizičkom osobom nisu lični
								podaci i mogu se koristiti u bilo koje poslovne
								svrhe.{" "}
							</p>
							<p>
								Lične podatke o vama prikupljamo iz različitih
								izvora. Informacije prikupljamo od vas direktno
								(npr. kada nas kontaktirate ili kreirate račun
								kod nas), automatski, (npr. podatke prikupljene
								putem kolačića i sličnih tehnologija kada
								koristite Mentorios&nbsp;usluge), i iz drugih
								izvora, uključujući komercijalno dostupne
								izvore, kao &scaron;to su javne baze podataka
								(gdje je to zakonom dozvoljeno). Ovi podaci mogu
								uključivati identifikatore (ime, adresu
								e-po&scaron;te, po&scaron;tansku adresu,
								korisničko ime, IP adresu i internetske
								identifikatore), demografske podatke (dob i
								spol) i informacije vezane za mrežne aktivnosti
								(interakcije s webom ili drugim digitalnim
								sadržajem; bilo da otvarate, komunicirate sa
								na&scaron;im elektronskim komunikacijama ili ih
								prosljeđujete i kako komunicirate sa oglasima
								koje nudimo mi ili treća lica).{" "}
							</p>
							<p>
								Na primjer, prikupljamo, obrađujemo i koristimo
								va&scaron;e lične podatke kada:{" "}
							</p>
							<ul>
								<li>
									registrujte se za Mentorios&nbsp;račun ili
									se prijavite na postojeći račun;{" "}
								</li>
								<li>
									komunicirate sa
									Mentorios&nbsp;uslugama;{" "}
								</li>
								<li>naručite proizvode ili sadržaj od nas;</li>
								<li>
									koristite Mentorios&nbsp;usluge za pristup
									elektronskom sadržaju;{" "}
								</li>
								<li>
									kontaktirate na&scaron;u korisničku
									podr&scaron;ku.{" "}
								</li>
							</ul>
							<h3>A. Informacije o registraciji i nalogu </h3>
							<p>
								Kada kreirate račun, dobrovoljno nam dajete
								određene lične podatke, kao &scaron;to su
								va&scaron;a adresa e-po&scaron;te i
								&scaron;ifra.{" "}
							</p>
							<h3>B. Informacije o profilu </h3>
							<p>
								Također možete popuniti opcionalni profil za
								registraciju, koji može uključivati va&scaron;e
								ime, spol, datum rođenja, kontakt telefon i sve
								dodatne opcionalne informacije koje
								odaberete.{" "}
							</p>
							<h3>C. Informacije o plaćanju </h3>
							<p>
								Kada odaberete pretplatu, automatski ćete biti
								preusmjereni na Monri platnu platformu,
								na&scaron;eg partnera za procesiranje plaćanja.
								Mentorios ne skladišti niti obrađuje va&scaron;e
								podatke o plaćanju direktno.
							</p>
							<p>
								Na Monri platformi ćete biti zatraženi da
								unesete sljedeće podatke: broj kartice, datum
								isteka kartice, CVC kod i zemlju iz koje
								vr&scaron;ite plaćanje. Svi ovi podaci se
								prikupljaju, skladište i obrađuju isključivo od
								strane Monri platforme u skladu sa PCI DSS
								standardima sigurnosti.
							</p>
							<p>
								Mentorios prima samo potvrdu o izvr&scaron;enoj
								transakciji (status plaćanja i identifikator
								transakcije) kako bi mogao aktivirati
								va&scaron;u pretplatu. Va&scaron;i podaci o
								plaćanju nikada ne prolaze kroz na&scaron;e
								servere niti se pohranjuju u na&scaron;im bazama
								podataka.
							</p>
							<p>
								Za vi&scaron;e informacija o tome kako Monri
								rukuje va&scaron;im podacima, molimo pogledajte{" "}
								<a
									href="https://https://monri.com/"
									target="_blank"
									rel="noopener noreferrer"
								>
									Monri
								</a>
								.
							</p>
							<h3>D. Komunikacije </h3>
							<p>
								Također možemo prikupljati informacije koje nam
								date u komunikaciji, kao &scaron;to je kada
								pi&scaron;ete recenziju ili nas kontaktirate s
								pitanjem, komentarom ili zahtjevom. Možete
								odabrati da nam pružite određene informacije
								kada ispunite obrazac, podnesete zahtjev
								na&scaron;em timu za brigu o korisnicima,
								odgovorite na anketu, po&scaron;aljete ocjene i
								recenzije ili učestvujete u promocijama ili
								takmičenjima.{" "}
							</p>
						</section>

						<section data-section="mentorios-services">
							<h2 id="mentorios-services">
								Informacije o korištenju Mentorios usluga
							</h2>
							<h3>A. Informacije o upotrebi </h3>
							<p>
								Prikupljamo lične podatke kada koristite ili na
								drugi način komunicirate sa Mentorios uslugama.
								Na primjer, prikupljamo informacije o tome kako
								koristite Mentorios uslugu, kao &scaron;to su
								stranice koje pregledavate, stopa po kojoj
								konzumirate obrazovni sadržaj (koliko često i
								koliko dugo), kategorije kurseva, predavači ili
								teme koje preferirate i pretraživanja koja
								vr&scaron;ite ili podijelite, kurseve koje ste
								lajkovali, komentare koje ste ostavili, kao i
								web stranice koje ste pregledali putem linkova u
								komentarima. Ove informacije prikupljamo na
								različitim uređajima, aplikacijama i drugim
								alatima putem kojih pristupate i komunicirate sa
								Mentorios uslugama.{" "}
							</p>
							<h3>B. Informacije o uređaju </h3>
							<p>
								Prikupljamo određene tehničke informacije o
								va&scaron;em uređaju &ndash; kao &scaron;to su
								va&scaron;a IP adresa, tip uređaja, model i
								proizvođač uređaja, identifikator uređaja i tip
								i verzija operativnog sistema va&scaron;eg
								uređaja.{" "}
							</p>
							<h3>C. Transakcione informacije </h3>
							<p>
								Automatski prikupljamo određene informacije o
								va&scaron;im transakcijama na Uslugama, kao
								&scaron;to su naplaćeni iznos, datum i vrijeme i
								kori&scaron;tenje promocija.{" "}
							</p>
							<h3>
								D. Informacije koje prikupljamo iz drugih izvora
							</h3>
							<p>
								Možemo dobiti dodatne informacije o vama od
								pružatelja usluga trećih strana i/ili
								maloprodajnih partnera, kao &scaron;to su
								demografske podaci, va&scaron;e aktivnosti na i
								izvan Mentorios usluga putem partnerstava i
								na&scaron;ih trećih ogla&scaron;ivača.
								Informacije koje prikupljamo možemo dopuniti
								informacijama dobijenim od dobavljača podataka i
								komercijalno dostupnih izvora (npr. demografske
								informacije i dodatne kontakt informacije).{" "}
							</p>
							<p>
								Pored toga, možemo izvući zaključke o
								va&scaron;im preferencijama i karakteristikama
								iz bilo kojih va&scaron;ih ličnih podataka koje
								prikupljamo da bismo razvili evidenciju o
								va&scaron;im potencijalnim preferencijama,
								karakteristikama, predispozicijama,
								pona&scaron;anju, stavovima, sposobnostima i
								sklonostima.{" "}
							</p>
							<h3>E. Registracija preko trećih lica</h3>
							<p>
								Pružamo vam mogućnost da se prijavite na
								Mentorios usluge koristeći račun koji već imate
								kod drugog provajdera (Google).{" "}
							</p>
							<h3>F. Kategorije informacija koje prikupljamo</h3>
							<p>
								Informacije koje prikupljamo gore opisanim
								metodama uključuju:{" "}
							</p>
							<ul>
								<li>
									Identifikatori: Na primjer, va&scaron;e ime,
									adresa e-po&scaron;te, po&scaron;tanska
									adresa, korisničko ime, IP adresa i mrežni
									identifikatori.{" "}
								</li>
								<li>
									Demografske podatke: kao &scaron;to su
									va&scaron;e godine i spol.{" "}
								</li>
								<li>
									Informacije o transakcijama: kao &scaron;to
									su proizvodi koje kupujete, pristupate ili
									pregledate; pretplate; metode plaćanja; i
									programe popusta.{" "}
								</li>
								<li>
									Aktivnosti na mreži: Na primjer, povijest
									pregledavanja i pretraživanja; interakcije s
									webom ili drugim digitalnim sadržajem; da li
									otvarate, komunicirate ili prosljeđujete
									na&scaron;u elektronsku komunikaciju; i kako
									komunicirate s oglasima koje nudimo mi ili
									treća lica.{" "}
								</li>
								<li>
									Informacije o lokaciji naplate: Na osnovu
									informacija koje date ili koje ste
									zaključili iz va&scaron;e IP adrese, kako
									bismo osigurali da imamo pravo da vam
									omogućimo pristup pretplati koju želite da
									aktivirate.{" "}
								</li>
								<li>
									Zaključci: Kao &scaron;to je gore navedeno,
									možemo koristiti informacije koje
									prikupljamo da identifikujemo va&scaron;e
									potencijalne preferencije, karakteristike,
									psiholo&scaron;ke trendove, predispozicije,
									pona&scaron;anja, stavove, sposobnosti i
									sklonosti.{" "}
								</li>
							</ul>
						</section>

						<section data-section="children">
							<h2 id="children">Djeca mlađa od 16 godina</h2>
							<p>
								Mentorios ne prikuplja svjesno lične podatke
								djece mlađe od 16 godina. Prilikom registracije,
								korisnici su obavezni da potvrde svoju starost.
								U određenim slučajevima, možemo koristiti
								tehničke mjere ili zahtijevati dodatnu
								verifikaciju (npr. potvrdu putem e-maila ili
								dodatne dokumente) kako bismo osigurali da
								korisnik ispunjava starosne uslove.{" "}
							</p>
							<p>
								Ako roditelj ili staratelj vjeruje da smo
								nenamjerno prikupili podatke maloljetnog
								korisnika, molimo da nas kontaktira na
								mentoriosedu@gmail.com, kako bismo odmah
								uklonili te podatke.{" "}
							</p>
						</section>

						<section data-section="how-why">
							<h2 id="how-why">
								Kako i zašto koristimo informacije
							</h2>
							<p>
								Va&scaron;e lične podatke možemo koristiti u
								sljedeće svrhe:{" "}
							</p>
							<ul>
								<li>
									Podaci poslovnih partnera: U slučajevima
									kada Mentorios prima email adrese ili druge
									lične podatke zaposlenika od poslovnih
									partnera, ti podaci će se koristiti
									isključivo za kreiranje korisničkih računa i
									omogućavanje pristupa platformi. Mentorios
									garantuje da ovi podaci neće biti
									kori&scaron;teni za marketin&scaron;ke
									svrhe, analitiku ili dijeljeni s trećim
									stranama bez izričitog pristanka poslovnog
									partnera ili krajnjih korisnika.{" "}
								</li>
								<li>
									Identifikacija i autentifikacija: Koristimo
									va&scaron;e identifikatore da potvrdimo
									va&scaron; identitet kada pristupate svom
									nalogu i da osiguramo sigurnost va&scaron;ih
									ličnih podataka;{" "}
								</li>
								<li>
									Rukovanje Mentorios uslugama: Obrađujemo
									va&scaron;e lične podatke kako bismo vam
									omogućili pristup Mentorios uslugama i da
									bismo obradili va&scaron;e transakcije, kako
									ste tražili. Koristimo lične podatke, kao
									&scaron;to je va&scaron;a lokacija, da bismo
									utvrdili da li je sadržaj dostupan u
									va&scaron;oj regiji. Koristimo informacije
									da pružimo i pobolj&scaron;amo Mentorios
									usluge, identifikujemo i otklonimo
									gre&scaron;ke i analiziramo Mentorios
									usluge;{" "}
								</li>
								<li>
									Upravljanje va&scaron;im nalogom: Koristimo
									lične podatke za kreiranje, održavanje i
									nadgledanje va&scaron;eg naloga.{" "}
								</li>
								<li>
									Pobolj&scaron;anje Mentorios usluga:
									analiziramo informacije o tome kako
									koristite Mentorios usluge kako bismo
									pružili pobolj&scaron;ano iskustvo za sve
									korisnike;{" "}
								</li>
								<li>
									Komunikacija s vama: Va&scaron;e lične
									podatke možemo koristiti za komunikaciju s
									vama, na primjer ako pružamo informacije o
									promjenama odredbi i uslova, da izdajemo
									sigurnosna upozorenja ili podsjetnike, ili
									ako nam se obratite s pitanjima;{" "}
								</li>
								<li>
									Marketing: Va&scaron;e lične podatke možemo
									koristiti da saznamo o interesima
									na&scaron;ih kupaca, da izgradimo profil o
									vama i da vas smjestimo u određene
									marketin&scaron;ke segmente, te da
									identifikujemo uređaje koje koristite za
									pristup digitalnom sadržaju i Mentorios
									uslugama kako bismo razumjeli bolje
									va&scaron;e preferencije i da na
									odgovarajući način personalizujemo
									marketin&scaron;ke poruke koje vam
									&scaron;aljemo. Također možemo koristiti
									va&scaron;e identifikatore da vam
									&scaron;aljemo marketin&scaron;ke
									komunikacije o Mentorios uslugama i drugim
									proizvodima ili uslugama koje bi vas mogle
									zanimati, podložno bilo kakvom pristanku
									koji se može zahtijevati prema važećem
									zakonu. Možete povući bilo koju saglasnost
									koju ste dali u bilo koje vrijeme;{" "}
								</li>
								<li>
									Personalizirano ogla&scaron;avanje i ponovni
									marketing: Mentorios koristi lične podatke
									da: (1) posluži ciljanim ogla&scaron;avanjem
									koje bi vas moglo zanimati na osnovu
									aktivnosti va&scaron;eg uređaja i
									pretpostavljenih interesa (2) mjerilo
									učinkovitost ciljanog ogla&scaron;avanja i
									(3) razumjelo upotrebu na&scaron;ih usluga.
									Mentorios-ovi ogla&scaron;ivači trećih
									strana mogu koristiti lične podatke (kao
									&scaron;to su kolačići, identifikatori
									platformskih uređaja, softverski agenti i IP
									adresa) za isporuku ciljanih reklama,
									mjerenje njihove učinkovitosti i
									razumijevanje kori&scaron;tenja i
									posjećenosti na&scaron;ih usluga i drugih
									aplikacija i web stranica koje prate ove
									kompanije. Nemamo pristup ili kontrolu nad
									kolačićima, identifikatorima platformskih
									uređaja, softverskim agentima ili drugim
									tehnologijama koje oni mogu koristiti. Ako
									se nalazite u Evropskom ekonomskom prostoru,
									možete upravljati svojim pristankom na to
									kako se takvi podaci prikupljaju i kako
									Mentorios dijeli lične podatke za ponovno
									ogla&scaron;avanje ili ponovno ciljanje
									ogla&scaron;avanja kori&scaron;tenjem gumba
									Prikaži postavke privatnosti na baneru
									na&scaron;e web stranice za pristup
									na&scaron;em području postavki
									kolačića;{" "}
								</li>
								<li>
									Upravljanje takmičenjima: S vremena na
									vrijeme, Mentorios vas može pozvati da
									učestvujete u raznim takmičenjima ili
									promocijama. Ako odlučite da učestvujete u
									takmičenju ili promociji, va&scaron;i lični
									podaci se mogu koristiti za administriranje
									takmičenja, kako je navedeno u primenjivim
									uslovima.{" "}
								</li>
								<li>
									Ostvarivanje na&scaron;ih prava: Va&scaron;e
									lične podatke možemo koristiti za
									ostvarivanje ili za&scaron;titu na&scaron;ih
									zakonskih prava tamo gdje je to potrebno, na
									primjer da bismo otkrili, spriječili i
									odgovorili na tužbe za prevaru, zahtjeve za
									kr&scaron;enje prava intelektualnog
									vlasni&scaron;tva ili kr&scaron;enje zakona
									ili na&scaron;ih odredbi i uslova, da
									odgovori na zahtjeve organa za provođenje
									zakona ili drugih trećih strana i da osigura
									Mentorios usluge;{" "}
								</li>
								<li>
									Usklađenost sa na&scaron;im obavezama:
									Va&scaron;e lične podatke možemo obraditi
									kako bismo bili u skladu sa zakonskim ili
									regulatornim zahtjevima, gdje je to
									propisano zakonom, kao &scaron;to je odgovor
									na sudske naloge ili u skladu sa propisima o
									privatnosti ili finansijskim propisima;{" "}
								</li>
								<li>
									Prilagođavanje va&scaron;eg iskustva: Kada
									koristite Mentorios usluge, možemo koristiti
									va&scaron;e lične podatke da
									pobolj&scaron;amo va&scaron;e iskustvo, kao
									&scaron;to je pružanje interaktivnih ili
									personalizovanih elemenata i pružanje
									sadržaja zasnovanog na va&scaron;im
									interesima;{" "}
								</li>
								<li>
									Za&scaron;tita od &scaron;tete: Lične
									podatke možemo koristiti po potrebi da
									za&scaron;titimo prava i sigurnost nas, vas
									ili drugih, kao &scaron;to su sigurnost,
									prevencija prevara i otkrivanje
									incidenata.{" "}
								</li>
							</ul>
						</section>

						<section data-section="sharing">
							<h2 id="sharing">Dijeljenje informacija</h2>
							<p>
								Određene lične podatke možemo otkriti pružaocima
								usluga, poslovnim partnerima ili filijalama.
								Možemo dijeliti informacije s određenim trećim
								stranama za kolačiće i praćenje koje su
								kontrolori podataka (pogledajte Pravila o
								kolačićima).{" "}
							</p>
							<h3>A. Pružaoci usluga i poslovni partneri </h3>
							<p>
								Da bismo podržali na&scaron;e poslovne svrhe,
								otkrivamo va&scaron;e lične podatke pružaocima
								usluga i poslovnim partnerima koji su obrađivači
								podataka. Va&scaron;e lične podatke otkrivamo
								na&scaron;im pružaocima usluga koji obavljaju
								poslovne usluge i/ili operacije u na&scaron;e
								ime ili prema na&scaron;im uputstvima.{" "}
							</p>
							<p>
								Na primjer, možemo se udružiti s drugim
								kompanijama za obradu sigurnih plaćanja,
								pružanje usluga provjere autentičnosti,
								optimizaciju Mentorios usluga, ispunjavanje
								narudžbi, obavljanje analitike, slanje
								na&scaron;ih biltena i marketin&scaron;kih
								e-poruka, podr&scaron;ku uslugama e-po&scaron;te
								i slanja poruka, administriranje na&scaron;ih
								promocija, pružanje usluga ciljanog
								ogla&scaron;avanja kao procesor za Mentorios i
								pružanja nagradne igre, takmičenja i ankete.
								Neki od na&scaron;ih pružatelja usluga ili
								poslovnih partnera mogu angažirati svoje
								vlastite pružatelje usluga ili poslovne partnere
								da nam dodatno pomognu. Osim ako nije drugačije
								navedeno, od ovih kompanija zahtijevamo da
								koriste lične podatke samo u svrhe opisane u
								ovoj Politici.{" "}
							</p>
							<h3>
								B. Agencije za provođenje zakona, sudovi,
								regulatori i državni organi{" "}
							</h3>
							<p>
								Informacije koje prikupljamo, uključujući lične
								podatke, možemo podijeliti s organima za
								provođenje zakona ili na drugi način u skladu sa
								bilo kojim zakonskim ili regulatornim zahtjevima
								ili naredbom suda ili druge javne agencije,
								regulatora, vladinog tijela ili druge treće
								strane za koju vjerujemo da je to neophodno da
								bismo ispunili zakonsku ili regulatornu obavezu
								ili na drugi način za&scaron;titili na&scaron;a
								prava ili prava bilo koje treće strane.{" "}
							</p>
							<h3>C. U kontekstu transakcije </h3>
							<p>
								Podatke koje prikupljamo, uključujući lične
								podatke, možemo podijeliti sa bilo kojom trećom
								stranom koja kupuje ili na koju prenosimo svu
								ili uglavnom svu na&scaron;u imovinu i
								poslovanje. Ukoliko dođe do takve prodaje ili
								prijenosa, uložit ćemo razumne napore da
								poku&scaron;amo osigurati da entitet kojem
								prenosimo va&scaron;e lične podatke koristi ih
								na način koji je u skladu s ovom Politikom
								privatnosti.{" "}
							</p>
							<p>
								Veliku pažnju posvećujemo za&scaron;tititi
								va&scaron;ih ličnih podataka i uspostavili smo
								mehanizme za njihovu za&scaron;titu kada se
								prenose na međunarodnom nivou, u skladu sa
								važećim zakonom. Postavili smo odgovarajuće
								mjere za&scaron;titite (kao &scaron;to su
								ugovorne obaveze) u skladu sa primjenjivim
								zakonskim zahtjevima kako bismo osigurali da su
								va&scaron;i podaci adekvatno za&scaron;tićeni.
								Za vi&scaron;e informacija o odgovarajućim
								za&scaron;titnim mjerama, kontaktirajte nas na{" "}
								<a href="mailto:mentoriosedu@gmail.com">
									mentoriosedu@gmail.com{" "}
								</a>
							</p>
							<p>
								Va&scaron;i lični podaci mogu se prenijeti i
								obrađivati izvan zemlje u kojoj boravite,
								uključujući zemlje koje možda nemaju iste zakone
								o za&scaron;tititi podataka kao va&scaron;a
								država. Ako prenosimo podatke izvan Evropskog
								ekonomskog prostora (EEA), osiguravamo da su
								podaci za&scaron;tićeni putem:{" "}
							</p>
							<ol start="1">
								<li>
									Standardnih ugovornih klauzula
									(SCC)&nbsp;odobrenih od strane Evropske
									komisije, koje osiguravaju da treće strane
									&scaron;tite podatke korisnika u skladu s
									GDPR-om.{" "}
								</li>
								<li>
									Dodatnih sigurnosnih mjera, uključujući
									enkripciju i stroge kontrole pristupa.{" "}
								</li>
								<li>
									Saradnje s provajderima koji su
									certificirani prema okvirima
									za&scaron;titite privatnosti, poput EU-SAD
									Data Privacy Frameworka (ako se
									primjenjuje).{" "}
								</li>
							</ol>
						</section>

						<section data-section="legal-basis">
							<h2 id="legal-basis">
								Pravna osnova za korištenje podataka
							</h2>
							<h3>
								A. Pravna osnova za obradu va&scaron;ih ličnih
								podataka ako se nalazite u EGP-u{" "}
							</h3>
							<p>
								Ako koristite Mentorios usluge dok ste u
								Evropskom ekonomskom prostoru (EEA), moramo
								imati zakonsku osnovu za obradu va&scaron;ih
								ličnih podataka u gore navedene svrhe,
								uključujući podatke primljene sa platformi
								dru&scaron;tvenih medija, podatke primljene iz
								drugih izvora koji se koriste za statistiku ili
								podatke podijeljeno sa trećim
								ogla&scaron;ivačima. Postoje različite pravne
								osnove na koje se oslanjamo da koristimo
								va&scaron;e lične podatke, a to su:{" "}
							</p>
							<p>
								Izvr&scaron;enje ugovora &ndash; Upotreba
								va&scaron;ih ličnih podataka može biti neophodna
								za održavanje va&scaron;eg naloga, pružanje
								usluga i slanje e-po&scaron;te i poruka u vezi
								sa administracijom i radom va&scaron;eg
								Mentorios naloga i/ili Mentorios usluge.{" "}
							</p>
							<p>
								Pristanak &ndash; Oslanjaćemo se na va&scaron;
								pristanak za kori&scaron;tenje (i) tehničkih
								informacija u vezi s kolačićima; i (ii)
								va&scaron;e lične sve informacije u
								marketin&scaron;ke i reklamne svrhe. Svoj
								pristanak možete povući u bilo kom trenutku tako
								&scaron;to ćete pratiti vezu za odjavu u bilo
								kojoj marketin&scaron;koj komunikaciji koju
								primite od nas.{" "}
							</p>
							<p>
								Legitimni interesi &ndash; Va&scaron;e lične
								podatke možemo koristiti za na&scaron;e
								legitimne interese da pobolj&scaron;amo
								na&scaron;e proizvode i usluge i sadržaj
								dostupan na Mentorios platformi. Ova
								pobolj&scaron;anja zavise od analize (na
								primjer) načina na koji koristite platformu, kao
								&scaron;to su stranice koje pregledavate, stopa
								po kojoj konzumirate obrazovni sadržaj (koliko
								često i koliko dugo), kategorije kurseva,
								predavači ili teme koje preferirate i
								pretraživanja koje vr&scaron;ite ili dijelite,
								kurseve koje ste lajkovali, komentare koje ste
								ostavili, web stranice koje ste pregledali putem
								veza, stopu uspje&scaron;nosti bilo koje
								promocije ili događaja, određene tehničke
								informacije o va&scaron;em uređaju ili kada
								pristupite na&scaron;im aplikacijama putem
								određenog uređaja, putanje kupovine ili
								transakcijskih podataka i interakcije brige o
								korisnicima. Također ćemo koristiti va&scaron;e
								lične podatke u sigurnosne svrhe i za dijeljenje
								informacija sa na&scaron;im filijalama za
								internu administraciju na osnovu legitimnog
								interesa.{" "}
							</p>
							<p>
								Pravna obaveza i javni interes &ndash; Tamo gdje
								je na to primoran važeći zakon, možemo također
								imati zakonsku obavezu da prikupimo va&scaron;e
								lične podatke, ili možda na drugi način trebamo
								za&scaron;tititi va&scaron;e lične podatke i
								va&scaron;e vitalne interese ili interese druge
								osobe.{" "}
							</p>
							<p>
								Ako trebamo dalje obraditi va&scaron;e lične
								podatke, obavijestit ćemo vas da li postoji
								drugačija pravna osnova za tu dalju obradu koja
								nije kompatibilna s obavje&scaron;tenjima i
								pristancima koje već imamo od vas, a mi ćemo vam
								pružiti sve relevantne dodatne informacije i
								opcije pristanka.{" "}
							</p>
							<h3>
								B. Va&scaron; izbor i va&scaron;a prava nad
								va&scaron;im ličnim podacima.{" "}
							</h3>
							<p>
								Ako posjećujete Mentorios web stranicu iz EEA
								ili bilo koje druge jurisdikcije sa zakonima
								sličnim Općoj uredbi o za&scaron;tititi podataka
								(GDPR) ili ste stanovnik Kalifornije, SAD
								(pogledajte dolje), imate određena prava, u
								skladu s primjenjivim domaćim zakonom i
								ograničenja, uključujući:{" "}
							</p>
							<ul>
								<li>
									Pravo da budete informisani: Korisnici
									moraju biti informisani kako i za&scaron;to
									se njihovi podaci prikupljaju, prije nego se
									ti podaci preuzmu.{" "}
								</li>
								<li>
									Pravo na pristup podacima: Korisnici imaju
									pravo da pristupe i zatraže kopiju njihovih
									ličnih podataka i ostalih dodatnih
									informacija. Na zahtjev za pristup podacima
									treba se odgovoriti u &scaron;to kraćem
									roku, a najdalje mjesec dana nakon
									zaprimanja zahtjeva. Informacije trebaju
									biti dostavljene sigurno, u konciznom
									formatu u kojem mu je lako pristupiti.
									Dodatni novac ne smije biti tražen od
									korisnika za takav zahtjev{" "}
								</li>
								<li>
									Pravo na izmjene: Korisnici imaju pravo da
									izmjene ili dopune netačne ili podatke koje
									nisu vi&scaron;e relevantni.{" "}
								</li>
								<li>
									Pravo na brisanje podataka: Korisnici imaju
									pravo zatražiti da se njihovi podaci
									vi&scaron;e ne procesuiraju u određene
									svrhe, ili da budu obrisani.{" "}
								</li>
								<li>
									Pravo na ograničenu obradu podataka:
									Korisnici imaju pravo da zabrane ili
									ograniče obradu njihovih ličnih
									podataka.{" "}
								</li>
								<li>
									Pravo na prenosivost podataka: Korisnici
									imaju pravo da preuzmu svoje lične podatke i
									iskoriste ih u lične svrhe kroz različite
									usluge koje im dopu&scaron;taju siguran
									prenos, kopiranje ili premje&scaron;tanje
									podataka iz jedne IT sredine, u drugu. U
									slučaju ovog zahtjeva, korisnici trebaju
									dobiti odgovor na zahtjev najkasnije jedan
									mjesec od zaprimanja zahtjeva.{" "}
								</li>
								<li>
									Pravo na prigovor: Korisnici imaju pravo
									uložiti žalbu na obradu njihovih ličnih
									podataka u određenim okolnostima. Korisnici
									imaju puno pravo da ne odobre
									kori&scaron;tenje njihovih ličnih podataka u
									marketin&scaron;ke svrhe. Na žalbu
									korisnicima treba odgovoriti najkasnije
									jedan mjesec od ulaganja žalbe.{" "}
								</li>
							</ul>
							<p>
								U vezi s na&scaron;im personaliziranim
								ogla&scaron;avanjem i aktivnostima ponovnog
								marketinga, možemo dijeliti lične podatke u
								dolje navedenim kategorijama s
								ogla&scaron;ivačima, kompanijama za digitalno
								ogla&scaron;avanje i drugim subjektima koji
								podržavaju na&scaron;e aktivnosti digitalnog
								ogla&scaron;avanja. U tom kontekstu, možemo
								"prodati" sljedeće kategorije va&scaron;ih
								ličnih podataka trećim stranama: internetske
								identifikatore i informacije o va&scaron;im
								aktivnostima na mreži. Možete registrovati svoje
								odustajanje slanjem poruke "Ne prodajte moje
								lične podatke" na e-mail
								mentoriosedu@gmail.com.{" "}
							</p>
							<h3>
								C. Kako ostvariti svoja prava na
								privatnost:{" "}
							</h3>
							<p>
								Kontaktirajte nas na mentoriosedu@gmail.com kako
								biste iskoristili bilo koje zakonsko pravo koje
								imate. U nekim slučajevima možete imati opciju
								da odbijete da nam date informacije. Međutim,
								va&scaron; izbor da ne pružite informacije može
								uticati na va&scaron;e kori&scaron;tenje
								određenih funkcija ili usluga. Imajte na umu da
								možemo zahtijevati dodatne informacije od vas
								kako bismo ispunili va&scaron; zahtjev, a možemo
								i odbiti va&scaron; zahtjev u skladu sa važećim
								zakonom.{" "}
							</p>
							<p>
								Ako kontaktiranje s nama ne rije&scaron;i
								va&scaron;u žalbu, možda imate pravo podnijeti
								žalbu svom tijelu za za&scaron;titu podataka
								(ako postoji u va&scaron;oj zemlji), a u slučaju
								bilo kakvog odbijanja za automatsku analizu
								prijevare, možete kontaktirati na&scaron;e
								odjeljenje za korisničku podr&scaron;ku na{" "}
								<a href="mailto:mentoriosedu@gmail.com">
									mentoriosedu@gmail.com.{" "}
								</a>
							</p>
							<p>
								Korisnici mogu ostvariti svoja prava u vezi s
								ličnim podacima tako &scaron;to će poslati
								zahtjev na mentoriosedu@gmail.com. Kada primimo
								va&scaron; zahtjev, odgovorit ćemo u roku od 30
								dana, u skladu s važećim zakonima. U nekim
								slučajevima, ovaj rok može biti produžen za
								dodatnih 60 dana, o čemu ćete biti
								obavije&scaron;teni.{" "}
							</p>
							<p>
								Prilikom podno&scaron;enja zahtjeva, možemo
								zatražiti dodatne informacije kako bismo
								potvrdili va&scaron; identitet i spriječili
								neovla&scaron;tenog pristupa. Ako va&scaron;
								zahtjev bude odbijen, imat ćete pravo podnijeti
								žalbu nadležnom tijelu za za&scaron;titu
								podataka u va&scaron;oj zemlji.{" "}
							</p>
							<h3>D. Dodatna korisnička prava </h3>
							<p>
								Možete se odjaviti ili isključiti primanje
								marketin&scaron;kih komunikacija od nas u svojim
								postavkama tako &scaron;to ćete kliknuti na
								"Postavke računa" pod "Moj račun" nakon
								&scaron;to se prijavite na svoj Mentorios račun,
								ili možete kliknuti na vezu "Otkaži pretplatu"
								na dnu automatske e-po&scaron;te. Također možete
								deaktivirati svoj Mentorios račun klikom na gumb
								"Zatvori račun". Imajte na umu da čak i ako
								odustanete od primanja marketin&scaron;ke
								komunikacije, možemo nastaviti slati vam
								nemarketin&scaron;ke e-poruke i druge vrste
								komunikacije, kako je dozvoljeno zakonom, kao
								&scaron;to su odgovori na va&scaron;e zahtjeve
								za podr&scaron;ku ili servisna e-poruka koja se
								odnosi na va&scaron; račun.{" "}
							</p>
							<p>
								Možete promijeniti informacije o svom računu
								tako &scaron;to ćete se povezati sa svojim
								Mentorios računom i promijeniti informacije
								navedene u funkciji "Postavke računa" na{" "}
								<a href="https://mentorios.com">
									https://mentorios.com
								</a>
								. Neke od ovih informacija su opcione i niste
								obavezni da nam ih date, međutim druge
								informacije kao &scaron;to su informacije o
								plaćanju su potrebne da bi Mentorios mogao da
								vam pruži svoje usluge. Od vas se ne traži da
								nam dajete nikakve informacije koje su
								nepotrebne za pružanje Mentorios usluga.{" "}
							</p>
							<p>
								Možete kontrolirati kori&scaron;tenje kolačića
								na nivou pretraživača. Ako odaberete da
								onemogućite kolačiće, to može ograničiti
								va&scaron;u upotrebu određenih funkcija ili
								funkcija na na&scaron;im uslugama. Za
								vi&scaron;e informacija o tome kako koristimo
								kolačiće i kako njima možete upravljati
								pogledajte na&scaron;u Politiku o kolačićima u
								nastavku.{" "}
							</p>
							<h3>E. Web stranice trećih strana</h3>
							<p>
								Mentorios usluge mogu sadržavati veze do web
								stranica koje nisu u vlasni&scaron;tvu ili pod
								kontrolom Mentorios-a. Podstičemo vas da budete
								svjesni ovih drugih web stranica trećih strana i
								njihovih izjava o privatnosti, jer ne možemo
								kontrolirati i nismo odgovorni za politike
								privatnosti ili prakse web stranica trećih
								strana. Ova Politika privatnosti odnosi se
								isključivo na informacije koje prikuplja
								Mentorios. Za vi&scaron;e informacija pogledajte
								Uslove kori&scaron;tenja.{" "}
							</p>
							<h3>F. Nemojte pratiti signale</h3>
							<p>
								Trenutno ne odgovaramo na signale &bdquo;ne
								prati&ldquo; web pretraživača ili druge
								mehanizme koji pružaju metodu za odustajanje od
								prikupljanja informacija na web stranicama ili
								drugim online uslugama. Ako to učinimo u
								budućnosti, ažurirat ćemo ovu politiku
								privatnosti.{" "}
							</p>
						</section>

						<section data-section="security">
							<h2 id="security">
								Sigurnost i zadržavanje podataka
							</h2>
							<p>
								Brinemo o sigurnosti Va&scaron;ih ličnih
								podataka. Primjenjujemo administrativne,
								tehničke i fizičke mjere osmi&scaron;ljene da
								osiguramo nivo sigurnosti koji odgovara riziku
								za lične podatke koje prikupljamo. Mi stalno
								procjenjujemo ove mjere za&scaron;titite kako
								bismo minimizirali rizike od novih sigurnosnih
								prijetnji kako postanu poznate. Međutim, nijedan
								informacioni sistem ne može biti 100% siguran.
								Osim toga, nismo odgovorni za sigurnost
								informacija koje nam prenosite preko mreža koje
								ne kontroliramo, uključujući internet i bežične
								mreže. Potrebna nam je i va&scaron;a pomoć:
								va&scaron;a je odgovornost da osigurate da su
								va&scaron;i lični podaci tačni i preporučujemo
								vam da osigurate da je va&scaron;a lozinka
								jedinstvena, sigurna i da se ne dijeli s trećim
								stranama.{" "}
							</p>
							<p>
								Zadržavamo informacije prikupljene putem
								Mentorios usluga sve dok imamo odnos s vama i
								dok ne odlučite zatvoriti svoj Mentorios račun.
								Nakon tog vremena, zadržat ćemo va&scaron;e
								lične podatke u slučaju da se želite ponovo
								pretplatiti na platformu, i kako va&scaron;
								progres ne bi bio izgubljen, sačuvaćemo
								va&scaron;e bilje&scaron;ke, označene rečenice,
								i slično.{" "}
							</p>
							<p>
								Mentorios poduzima niz sigurnosnih mjera kako bi
								za&scaron;titio va&scaron;e lične podatke od
								neovla&scaron;tenog pristupa, izmjene,
								otkrivanja ili uni&scaron;tavanja. Ove mjere
								uključuju, ali nisu ograničene na:{" "}
							</p>
							<ul>
								<li>
									Enkripciju podataka u prijenosu i pohrani,
									uključujući SSL/TLS protokole.{" "}
								</li>
								<li>
									Kontrolu pristupa, omogućujući pristup
									podacima samo ovla&scaron;tenim osobama na
									osnovu principa najmanjih privilegija.{" "}
								</li>
								<li>
									Redovno testiranje sigurnosti i nadzor
									sistema radi otkrivanja i sprječavanja
									sigurnosnih prijetnji.{" "}
								</li>
								<li>
									Sigurnosne kopije podataka, kako bi se
									osigurao oporavak u slučaju gubitka ili
									kompromitacije podataka.{" "}
								</li>
								<li>
									Dvostruku autentifikaciju za administrativne
									naloge, kako bi se dodatno smanjio rizik od
									neovla&scaron;tenog pristupa.{" "}
								</li>
							</ul>
							<p>
								Iako poduzimamo sve razumne mjere za
								za&scaron;titu va&scaron;ih podataka, nijedan
								sistem nije 100% siguran. Preporučujemo
								korisnicima da također poduzmu odgovarajuće
								mjere za&scaron;titite, kao &scaron;to su snažne
								lozinke i sigurne mrežne postavke.{" "}
							</p>
						</section>

						<section data-section="changes">
							<h2 id="changes">Promjene politike privatnosti</h2>
							<p>
								Možemo s vremena na vrijeme ažurirati ovu
								Politiku privatnosti. Datum stupanja na snagu
								trenutne Politike privatnosti naveden je na vrhu
								ove stranice. Možemo vas pismeno obavijestiti o
								tom gdje materijalno mijenjamo ove uslove, na
								primjer, postavljanjem banera na Uslugama,
								međutim preporučujemo vam da povremeno
								pregledate ovu stranicu radi ažuriranih
								uslova.{" "}
							</p>
						</section>

						<section data-section="contact">
							<h2 id="contact">Kako nas kontaktirati</h2>
							<p>
								Ako želite da nam se obratite sa pitanjima o
								va&scaron;oj privatnosti, praksi
								za&scaron;titite podataka ili želite da
								bri&scaron;ete podatke, kontaktirajte nas na
								mentoriosedu@gmail.com.{" "}
							</p>
						</section>
					</div>
				</div>
			</Container>
			<Footer />
		</>
	);
}

export default PrivacyPolicy;
